import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal }          from '@ng-bootstrap/ng-bootstrap';

import { CompanyMessagesModel }     from '../companies/models/company.messages';
import { CustomerModel }           from './models/customer';
import { FlipperSidesModel }       from '../shared/components/flipper/typings/flipper.sides';
import { MessagesService }         from '../messages/messages.service';
import { MessengerService }        from '../messages/messenger/messenger.service';
import { TemplatedWordingService } from '../templates/templated-wording.service';

@Component({
  selector: 'wor-customer-email-statement',
  template: `
    <wor-flipper [side]="activeSide">
      <div front>
        <div class="modal-header bg-info title d-flex">
          <h1><i class="fa fa-file"></i></h1>
          <h1 translate="REPORT_SPACE.TITLES.EMAIL_STATEMENT"></h1>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-6" *ngIf="!email.attachment_filters.statement">
              <label id="begin_date_label" class="control-label" for="begin_date"
                translate="REPORT_SPACE.FIELD.BEGIN_DATE">
              </label>
              <div class="input-group">
                <span class="input-group-addon date"><i class="fa fa-calendar"></i></span>
                <input type="text" id="begin_date" class="form-control"
                  name="begin_date"
                  [(ngModel)]="email.attachment_filters.begin_date">
              </div>
            </div>
            <div class="col-sm-6" *ngIf="!email.attachment_filters.statement">
              <label id="end_date_label" class="control-label" for="end_date"
                translate="REPORT_SPACE.FIELD.END_DATE">
              </label>
              <div class="input-group">
                <span class="input-group-addon date"><i class="fa fa-calendar"></i></span>
                <input type="text" id="end_date" class="form-control"
                  name="end_date"
                  [(ngModel)]="email.attachment_filters.end_date">
              </div>
            </div>
            <div class="col-sm-6" *ngIf="email.attachment_filters.statement">
              <label id="customer_statements_end_date_label" class="control-label"
                for="customer_statements_end_date"
                translate="REPORT_SPACE.FIELD.AS_AT">
              </label>
              <div class="input-group">
                <span class="input-group-addon date"><i class="fa fa-calendar"></i></span>
                <input type="text" id="customer_statements_end_date" class="form-control"
                  name="customer_statements_end_date"
                  [(ngModel)]="email.attachment_filters.as_at">
              </div>
            </div>
          </div>
          <div class="row top-buffer text-left">
            <div class="col-sm-6" *ngIf="!email.attachment_filters.statement">
              <label id="include_paid_label" class="control-label" for="include_paid"
                translate="REPORT_SPACE.FIELD.SHOW_PAID_TRANSACTIONS">
              </label>
              <label class="switch switch-success">
                <input type="checkbox" id="include_paid"
                  name="include_paid" class="switch-input"
                  [(ngModel)]="email.attachment_filters.include_paid">
                <span class="switch-label"
                  [attr.data-off]="'GENERAL_SPACE.SWITCH.NO' | translate"
                  [attr.data-on]="'GENERAL_SPACE.SWITCH.YES' | translate">
                </span>
                <span class="switch-handle"></span>
              </label>
            </div>
            <div class="col-sm-6">
              <label id="statement_label" class="control-label" for="statement"
                translate="REPORT_SPACE.FIELD.30_60_90_STATEMENT">
              </label>
              <br>
              <label class="switch switch-success">
                <input type="checkbox" id="statement"
                  name="statement" class="switch-input"
                  [(ngModel)]="email.attachment_filters.statement">
                <span class="switch-label"
                  [attr.data-off]="'GENERAL_SPACE.SWITCH.NO' | translate"
                  [attr.data-on]="'GENERAL_SPACE.SWITCH.YES' | translate">
                </span>
                <span class="switch-handle"></span>
              </label>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex align-items-center">
          <button type="button" class="btn btn-cancel"
            (click)="modal.dismiss()"
            translate="GENERAL_SPACE.BUTTON.CANCEL">
          </button>
          <button type="button" class="btn btn-success m-left-auto"
            (click)="activeSide = 'back'"
            translate="GENERAL_SPACE.BUTTON.NEXT">
          </button>
        </div>
      </div>
      <div back>
        <form class="form-horizontal" novalidate
          #form="ngForm"
          (ngSubmit)="send()">
          <div class="modal-header bg-info title d-flex">
            <h1><i class="fa fa-file"></i></h1>
            <h1>{{ email.name }}</h1>
          </div>
          <div class="modal-body">
            <div>
              <label for="email_address" class="control-label"
                translate="GENERAL_SPACE.FIELD.EMAIL">
              </label>
              <input type="text" name="email_address" id="email_address" class="form-control"
                [(ngModel)]="email.email_address">
            </div>
            <div>
              <label for="subject" class="control-label"
                translate="GENERAL_SPACE.MESSAGE.SUBJECT">
              </label>
              <input type="text" name="subject" id="subject" class="form-control"
                [(ngModel)]="email.subject">
            </div>
            <div class="top-buffer">
              <wor-text-editor
                [(model)]="email.body">
              </wor-text-editor>
            </div>
            <div class="d-flex align-items-center">
              <span *ngIf="email.attachment_type">
                <i class="fa fa-paperclip"></i>
                <span translate="GENERAL_SPACE.MESSAGE.ATTACHMENT_INCLUDED"></span>
              </span>
              <button type="button" class="btn btn-success m-left-auto"
                (click)="addTemplates()">
                <i class="fa fa-plus"></i>
                <span translate="GENERAL_SPACE.BUTTON.ADD_TEMPLATE"></span>
              </button>
            </div>
          </div>
          <div class="modal-footer d-flex align-items-center">
            <button type="button" class="btn btn-cancel"
              (click)="activeSide = 'front'"
              translate="GENERAL_SPACE.BUTTON.BACK">
            </button>
            <button type="submit" class="btn btn-success m-left-auto"
              [disabled]="resolving"
              translate="GENERAL_SPACE.BUTTON.SEND">
            </button>
          </div>
        </form>
      </div>
    </wor-flipper>
  `
})
export class CustomerEmailStatementComponent implements OnInit {
  @Input() customer       : CustomerModel;
  @Input() companyMessages: CompanyMessagesModel;

  activeSide: FlipperSidesModel = 'front';
  email     : any = {};
  resolving = false;

  constructor (
    public modal: NgbActiveModal,
    private messagesService: MessagesService,
    private messengerService: MessengerService,
    private templatedWordingService: TemplatedWordingService
  ) {}

  ngOnInit () {
    this.email = {
      attachment_id     : this.customer?.id,
      attachment_type   : 1,
      body              : this.companyMessages?.statement_email_message,
      email_address     : this.customer?.email,
      name              : this.customer?.display_name,
      attachment_filters: {
        as_at       : '*',
        begin_date  : '*',
        end_date    : '*',
        include_paid: true,
        statement   : false
      }
    };
  }

  addTemplates () {
    this.templatedWordingService.addTemplate('email')
      .then(( templates ) => {
        templates.forEach(template => {
          this.email.body = this.email.body
            ? `${ this.email.body }\n\n${ template.wording }`
            : template.wording;
        });
      })
      .catch(() => {});
  }

  send () {
    this.resolving = true;

    this.messengerService.sendEmail(this.email)
      .then(() => this.modal.close())
      .catch(( err ) => this.messagesService.error(err))
      .finally(() => {
        this.resolving = false;
      });
  }
}
